module.exports = __webpack_public_path__ + "media/images/application/template/icon-bim-objects-15a20d6058cbcd48324ffd433c1cda78.svg";